module.exports = __webpack_public_path__ + "img/home7.9f5bb157.jpg";